export type CharacterScope = 'library' | 'story' | 'all';

export const characterKeys = {
  all: ['characters'] as const,
  lists: () => [...characterKeys.all, 'list'] as const,
  list: (familyId: string, role?: string, scope: CharacterScope = 'library') =>
    [...characterKeys.lists(), familyId, role, scope] as const,
  storyList: (familyId: string) => [...characterKeys.all, 'storyList', familyId] as const,
  details: () => [...characterKeys.all, 'detail'] as const,
  detail: (id: string) => [...characterKeys.details(), id] as const,
  recent: (familyId: string) => [...characterKeys.all, 'recent', familyId] as const,
};
